import { trans } from "@mongez/localization";
import { ReactAtom } from "@mongez/react-atom";
import { cn } from "core/shared";
import { Button } from "~/design-system/components";
import { ItemsAtom, useLoadMore } from "../../hooks";

type LoadMoreProps = {
  itemsAtom: ReactAtom<ItemsAtom>;
  itemsAtomKey: string;
  actionUrl: string;
  children?: React.ReactNode;
  className?: string;
};

export function LoadMore({
  itemsAtom,
  itemsAtomKey,
  actionUrl,
  children,
  className,
}: LoadMoreProps) {
  const { loadMore, hasNextPage, isLoading } = useLoadMore({
    actionUrl,
    itemsAtom,
    itemsAtomKey,
  });

  if (!hasNextPage) return null;

  return (
    <Button
      className={cn(
        "mx-auto w-fit rounded-full border px-6 py-3 text-sm font-bold uppercase disabled:pointer-events-none disabled:opacity-50 md:px-8 md:py-4",
        className,
      )}
      onClick={loadMore}
      disabled={isLoading}
    >
      {isLoading ? trans("loading") : children || trans("viewMore")}
    </Button>
  );
}
